// Keep aligned with GET /api/onboarding; installation is tracked on this device.
export const ONBOARDING_API_STEP_KEYS = [
  'workScheduleConfigured',
  'clientCreated',
  'serviceCreated',
  'stockItemCreated',
  'visitCreated',
  'visitCompleted',
  'reservationEnabled',
  'publicReservationSetup',
  'qrPaymentsSetup',
] as const;

export type OnboardingProgress = Record<(typeof ONBOARDING_API_STEP_KEYS)[number], boolean>;
export const ONBOARDING_TOTAL_STEPS = ONBOARDING_API_STEP_KEYS.length + 1;

export const isOnboardingFullyCompleted = (
  progress: Partial<OnboardingProgress> | undefined,
  installed: boolean,
) => installed && !!progress && ONBOARDING_API_STEP_KEYS.every(key => progress[key] === true);
